module.exports = __webpack_public_path__ + "static/circle-1-e3cfdb57e2118be2757f4b1f20f93b7d.svg";